"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _StringOrRender = _interopRequireDefault(require("../helper/StringOrRender"));

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* babel-plugin-inline-import '../../img/confirmed-delivery.svg' */
var icon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxwYXRoIGlkPSJjIiBkPSJNMSAyaDE2djE2SDF6Ii8+CiAgICA8L2RlZnM+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxtYXNrIGlkPSJiIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjYSIvPgogICAgICAgIDwvbWFzaz4KICAgICAgICA8dXNlIGZpbGw9IiNGNjVBNUEiIGZpbGwtb3BhY2l0eT0iMCIgeGxpbms6aHJlZj0iI2EiLz4KICAgICAgICA8ZyBtYXNrPSJ1cmwoI2IpIj4KICAgICAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAyKSI+CiAgICAgICAgICAgICAgICA8dXNlIGZpbGw9IiNDNDQ3NDciIGZpbGwtb3BhY2l0eT0iMCIgeGxpbms6aHJlZj0iI2MiLz4KICAgICAgICAgICAgICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgeD0iMSIgeT0iMyIgZmlsbD0iI0ZGRiIgc3Ryb2tlPSIjMzI2QkVFIiBzdHJva2Utd2lkdGg9IjIiIHJ4PSIyIi8+CiAgICAgICAgICAgICAgICA8ZyBmaWxsPSIjNDJENDZDIiB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgMTYuMDcxIDEpIj4KICAgICAgICAgICAgICAgICAgICA8cmVjdCB3aWR0aD0iMiIgaGVpZ2h0PSI1IiByeD0iMSIvPgogICAgICAgICAgICAgICAgICAgIDxyZWN0IHdpZHRoPSI4IiBoZWlnaHQ9IjEuOTk5IiB5PSIzIiByeD0iMSIvPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPHJlY3Qgd2lkdGg9IjIiIGhlaWdodD0iNiIgeD0iNCIgZmlsbD0iIzMyNkJFRSIgcng9IjEiLz4KICAgICAgICAgICAgICAgIDxyZWN0IHdpZHRoPSIyIiBoZWlnaHQ9IjYiIHg9IjgiIGZpbGw9IiMzMjZCRUUiIHJ4PSIxIi8+CiAgICAgICAgICAgICAgICA8cmVjdCB3aWR0aD0iMiIgaGVpZ2h0PSI2IiB4PSIxMiIgZmlsbD0iIzMyNkJFRSIgcng9IjEiLz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";

var Card = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Card, _Component);

  var _super = _createSuper(Card);

  function Card() {
    var _this;

    (0, _classCallCheck2["default"])(this, Card);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(Card, [{
    key: "renderTitle",
    value: function renderTitle() {
      var _this$props = this.props,
          title = _this$props.title,
          icon = _this$props.icon;

      if (!title) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.titleContainer)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.title)
      }, icon && /*#__PURE__*/_react["default"].createElement("img", {
        src: icon,
        className: (0, _styling.css)(this.styles.icon),
        alt: "icon",
        draggable: false
      }), /*#__PURE__*/_react["default"].createElement(_StringOrRender["default"], {
        value: title
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          style = _this$props2.style,
          onClick = _this$props2.onClick,
          children = _this$props2.children,
          className = _this$props2.className,
          onMouseEnter = _this$props2.onMouseEnter,
          onMouseLeave = _this$props2.onMouseLeave,
          contentContainerStyle = _this$props2.contentContainerStyle;
      var rootCSS = (0, _styling.css)(this.styles.root, style, className);
      return /*#__PURE__*/_react["default"].createElement("article", {
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        className: rootCSS
      }, this.renderTitle(), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.content, contentContainerStyle)
      }, children));
    }
  }, {
    key: "styles",
    get: function get() {
      var showOverflow = this.props.showOverflow;
      var _this$context$theming = this.context.theming,
          _this$context$theming2 = _this$context$theming.theme,
          surfaceLightest = _this$context$theming2.surfaceLightest,
          surfaceLight = _this$context$theming2.surfaceLight,
          textBlack = _this$context$theming2.textBlack,
          fonts = _this$context$theming.fonts;
      var overflow = showOverflow ? "visible" : "hidden";
      return _aphrodite.StyleSheet.create({
        root: {
          borderRadius: 4,
          boxShadow: "0 2px 4px 0 rgba(175, 199, 209, 0.2)",
          border: "solid 1px rgba(175, 199, 209, 0.5)",
          overflow: overflow,
          backgroundColor: surfaceLightest,
          display: "flex",
          flexDirection: "column",
          fontFamily: fonts.regular
        },
        content: {
          flex: 1,
          backgroundColor: surfaceLightest
        },
        icon: {
          marginRight: 10,
          height: 25
        },
        title: {
          flex: 1,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          fontSize: 20,
          fontFamily: fonts.bold,
          fontStyle: "normal",
          fontStretch: "normal",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          paddingRight: 10,
          color: textBlack
        },
        titleContainer: {
          display: "flex",
          flexDirection: "row",
          background: surfaceLight,
          padding: "13px 20px"
        }
      });
    }
  }]);
  return Card;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.demoProps = {
  title: "Card Title",
  icon: icon
}, _class3.propDoc = {
  title: {
    required: false,
    defaultValue: "null",
    type: "string | ((() => ReactNode))",
    description: "Optional title of the card. Value is either a string," + " or a render function for custom title"
  },
  icon: {
    required: false,
    defaultValue: "null",
    type: "string",
    description: "Optional icon image of the card. " + "Icon is not rendered if the card as a custom render title"
  },
  showOverflow: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Whether to show overflow content outside the card"
  },
  contentContainerStyle: {
    required: false,
    defaultValue: "null",
    type: "CSSProperties",
    description: "Style the content container"
  }
}, _class3.discussion = "\n    Content of the card is specified with children.\n\n    ```\n    <Card title={\"Card Title\"} icon={icon}>\n      <div>Add content here</div>\n    </Card>\n    ```\n\n    Card with no title - very common.\n    ```\n    <Card>\n      <div>Add content here</div>\n    </Card>\n    ```\n  ", _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = Card;
exports["default"] = _default;